import axes from '../mixins/axes'

export default {
  name: 'LaXAxis',

  axis: 'x',

  space: [0, 20, 24, 20],

  mixins: [axes]
}
